module.exports = __webpack_public_path__ + "static/media/ic-scanner.53474f0b.png";